import { asRecord } from './common';

import { ORDER_DOCUMENT_CODES as codes, ORDER_DOCUMENT_STATES as states, type OrderDocumentCompleteness } from '../types/orderDocumentCompleteness';

/** Absent/redacted/malformed evidence never becomes a list of missing documents. */
export function normalizeOrderDocumentCompleteness(value: unknown): OrderDocumentCompleteness | undefined {
  const record = asRecord(value);
  if (!Array.isArray(record?.checks)) return undefined;
  const checks: OrderDocumentCompleteness['checks'] = [];
  for (const raw of record.checks) {
    const row = asRecord(raw);
    if (!row || !codes.includes(row.code as typeof codes[number]) || !states.includes(row.state as typeof states[number])) return undefined;
    checks.push({ code: row.code as typeof codes[number], state: row.state as typeof states[number],
      ...(typeof row.missingCount === 'number' && typeof row.totalCount === 'number'
        ? { missingCount: row.missingCount, totalCount: row.totalCount } : {}) });
  }
  return { checks };
}
